<template>
    <div v-if="isVisible" class="form-item">
        <div class="embedCode hasi18n" v-html="item.data.embedHtml"></div>
    </div>
</template>

<script>
import logicMixin from "../mixins/logic";

export default {
    name: 'Html',
    mixins: [logicMixin],
    props: {
        item: {
            type: Object
        }
    }
};
</script>

<style lang="scss" scoped>
.view {
    min-height: 50px;
}
</style>